import '../stylesheets/pyxis.sass';
import 'bootstrap';
import * as Routes from '../javascripts/routes/routes.js.erb';
import 'jquery';
import 'jquery-ujs';
import '../javascripts/pyxis/util';

window.Routes = Routes;
